import React, { useState } from "react"

const ReuseTable = (props) => {
    const { data, columns } = props;
    const [showFilter, setShowFilter] = useState({});
    const [selectedFilters, setSelectedFilters] = useState({});

    const toggleDropdown = (selector) => {
        setShowFilter((prev) => (prev === selector ? null : selector));
    };

    // Toggle checkbox selection inside dropdown
    const toggleOption = (selector, value) => {
        setSelectedFilters((prev) => {
            const current = prev[selector] || [];
            return {
                ...prev,
                [selector]: current.includes(value)
                    ? current.filter((v) => v !== value)
                    : [...current, value],
            };
        });
    };

    // Build filtered data
    const filteredData = data?.filter((row) => {
        return columns.every((col) => {
            const selected = selectedFilters[col.selector];
            if (!selected || selected.length === 0) return true;
            return selected.includes(row[col.selector]);
        });
    });

    return (
        <div className={props.className}>
            <table className="Data-Table mb-2">
                <thead>
                    <tr>
                        
                       {props.SNo &&  <th>S.No</th>}
                        {columns?.map((column, index) => (
                            <th key={index}
                                onClick={() => column.filterable && toggleDropdown(column.selector)}
                            >
                                {column.Hcell ? column.Hcell(column) : column.name}

                                {showFilter === column.selector && (
                                    <div className="dflex flexd-column Card gap-2 "
                                        style={{ position: "absolute", textAlign: "left", zIndex: "100" }}>
                                        {[...new Set(data.map((row) => row[column.selector]))].map(
                                            (value) => (
                                                <label key={value} className="dflex gap-2 alignitems" style={{ color: "black",minWidth:"5vw" }}>
                                                    <input type="checkbox"
                                                        checked={selectedFilters[column.selector]?.includes(value)}
                                                        onChange={() => toggleOption(column.selector, value)}
                                                    />
                                                    {value}
                                                </label>
                                            )
                                        )}
                                        {/* <button className="Buttons">ok</button> */}
                                    </div>
                                )}


                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {filteredData?.length > 0 ? filteredData?.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                           {props.SNo && <td>{rowIndex + 1}</td>}
                            {columns?.map((column, colIndex) => (
                                <td key={`${rowIndex}-${colIndex}`}>
                                    {column.cell ? column.cell(row) : row[column.selector]}
                                </td>
                            ))}
                        </tr>
                    )) :
                        <tr>
                            <td colSpan={columns?.length + 2} style={{ textAlign: "center" }} >
                                *** No records Found ***
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
};
export default ReuseTable;
